import type { GsCheck } from '@shared/api';
import { fmtMoney } from '@shared/lib/smetaLabels';
import { summaryNum } from '../helpers';
import { Metric, MetricVal, Metrics, Muted } from '../styles';

export function MarginSummary({ check }: { check: GsCheck }) {
  const s = check.summary;
  const marginTotal = summaryNum(s, 'margin_total_rub');
  const marginMatched = summaryNum(s, 'margin_matched_rub');
  const marginPct = summaryNum(s, 'margin_pct');
  const gpTotal = summaryNum(s, 'gp_total');
  const spTotal = summaryNum(s, 'sp_total');
  const matched = summaryNum(s, 'matched_count');
  const gpOnly = summaryNum(s, 'gp_only_count');
  const spOnly = summaryNum(s, 'sp_only_count');
  if (!s) return null;
  return (
    <Metrics>
      <Metric>
        <Muted>Маржа генподряда (тотально)</Muted>
        <MetricVal $accent>{fmtMoney(marginTotal)} ₽</MetricVal>
        <Muted>
          по парам: {fmtMoney(marginMatched)} ₽ · {marginPct?.toFixed(1) ?? '—'}% от СП
        </Muted>
      </Metric>
      <Metric>
        <Muted>Итог генподряда</Muted>
        <MetricVal>{fmtMoney(gpTotal)} ₽</MetricVal>
      </Metric>
      <Metric>
        <Muted>Итог субподряда</Muted>
        <MetricVal>{fmtMoney(spTotal)} ₽</MetricVal>
      </Metric>
      <Metric>
        <Muted>Покрытие</Muted>
        <MetricVal>{matched ?? 0} пар</MetricVal>
        <Muted>
          только ГП: {gpOnly ?? 0} · только СП: {spOnly ?? 0}
        </Muted>
      </Metric>
    </Metrics>
  );
}
